export default __webpack_public_path__ + "static/media/element_12.e73d7f7b.jpg";